import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  const s: any = {
    wrap: { background: '#0F1117', minHeight: '100vh', color: '#E8ECF4', padding: '40px 24px' },
    inner: { maxWidth: 800, margin: '0 auto' },
    h1: { color: '#E8ECF4', fontSize: 24, fontWeight: 800, marginBottom: 8 },
    h2: { color: '#00D4AA', fontSize: 16, fontWeight: 700, margin: '32px 0 12px' },
    p: { color: '#8892A4', fontSize: 14, lineHeight: 1.8, marginBottom: 12 },
    table: { width: '100%', borderCollapse: 'collapse' as const, marginBottom: 16 },
    th: { background: '#161B27', color: '#E8ECF4', fontSize: 13, padding: '10px 12px', border: '0.5px solid #2A3045', textAlign: 'left' as const },
    td: { color: '#8892A4', fontSize: 13, padding: '10px 12px', border: '0.5px solid #2A3045' },
  };

  return (
    <div style={s.wrap}>
      <div style={s.inner}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', color: '#8892A4', fontSize: 13, cursor: 'pointer', marginBottom: 24 }}>← 뒤로가기</button>
        <h1 style={s.h1}>개인정보처리방침</h1>
        <p style={{ ...s.p, color: '#4A5568' }}>시행일: 2026년 3월 22일</p>

        <p style={s.p}>
          진리커뮤니티(이하 "회사")는 셀러랭키(sellerranky.kr) 서비스 이용자의 개인정보를 중요시하며,
          「개인정보 보호법」 등 관련 법령을 준수합니다. 본 방침은 회사가 수집하는 개인정보의 항목,
          수집 목적, 보유 기간 및 처리 방법에 대해 안내합니다.
        </p>

        <h2 style={s.h2}>1. 수집하는 개인정보 항목</h2>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>구분</th>
              <th style={s.th}>수집 항목</th>
              <th style={s.th}>수집 목적</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={s.td}>회원가입</td>
              <td style={s.td}>이메일, 비밀번호(암호화), 이름</td>
              <td style={s.td}>회원 식별 및 서비스 제공</td>
            </tr>
            <tr>
              <td style={s.td}>유료 구독</td>
              <td style={s.td}>카드 빌링키(토스페이먼츠 보관), 결제 내역</td>
              <td style={s.td}>구독 결제 및 자동 갱신</td>
            </tr>
            <tr>
              <td style={s.td}>서비스 이용</td>
              <td style={s.td}>순위 조회 기록, 키워드 분석 기록</td>
              <td style={s.td}>서비스 제공 및 개선</td>
            </tr>
            <tr>
              <td style={s.td}>자동 수집</td>
              <td style={s.td}>IP 주소, 접속 로그, 쿠키</td>
              <td style={s.td}>서비스 보안 및 통계 분석</td>
            </tr>
          </tbody>
        </table>

        <h2 style={s.h2}>2. 개인정보 수집 및 이용 목적</h2>
        <p style={s.p}>
          회사는 다음 목적을 위해 개인정보를 처리합니다.<br />
          • 회원 가입 및 관리, 본인 확인<br />
          • 서비스 제공 및 콘텐츠 표시<br />
          • 구독 결제 처리 및 자동 갱신<br />
          • 순위 변동 알림 이메일 발송<br />
          • 서비스 개선 및 신규 기능 개발<br />
          • 법령 준수 및 분쟁 해결
        </p>

        <h2 style={s.h2}>3. 개인정보 보유 및 이용 기간</h2>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>항목</th>
              <th style={s.th}>보유 기간</th>
              <th style={s.th}>근거</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={s.td}>회원 정보</td>
              <td style={s.td}>탈퇴 후 즉시 삭제</td>
              <td style={s.td}>개인정보보호법</td>
            </tr>
            <tr>
              <td style={s.td}>결제 및 구독 기록</td>
              <td style={s.td}>5년</td>
              <td style={s.td}>전자상거래법</td>
            </tr>
            <tr>
              <td style={s.td}>접속 로그</td>
              <td style={s.td}>3개월</td>
              <td style={s.td}>통신비밀보호법</td>
            </tr>
            <tr>
              <td style={s.td}>이메일 인증 기록</td>
              <td style={s.td}>1일</td>
              <td style={s.td}>서비스 운영 정책</td>
            </tr>
          </tbody>
        </table>

        <h2 style={s.h2}>4. 개인정보 제3자 제공</h2>
        <p style={s.p}>
          회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
          단, 유료 구독 결제 처리를 위해 아래와 같이 제3자에게 최소한의 정보를 제공합니다.
        </p>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>제공 업체</th>
              <th style={s.th}>제공 항목</th>
              <th style={s.th}>이용 목적</th>
              <th style={s.th}>보유 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={s.td}>토스페이먼츠</td>
              <td style={s.td}>이름, 이메일, 결제정보</td>
              <td style={s.td}>구독 결제 처리</td>
              <td style={s.td}>결제 완료 후 5년</td>
            </tr>
          </tbody>
        </table>

        <h2 style={s.h2}>5. 개인정보 처리 위탁</h2>
        <p style={s.p}>
          회사는 서비스 제공을 위해 아래와 같이 개인정보 처리를 위탁합니다.
        </p>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>수탁 업체</th>
              <th style={s.th}>위탁 업무</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={s.td}>Google (Gmail)</td>
              <td style={s.td}>이메일 발송 (인증 코드, 알림)</td>
            </tr>
            <tr>
              <td style={s.td}>Cafe24</td>
              <td style={s.td}>서버 호스팅 및 데이터 보관</td>
            </tr>
          </tbody>
        </table>

        <h2 style={s.h2}>6. 이용자의 권리</h2>
        <p style={s.p}>
          이용자는 언제든지 다음 권리를 행사할 수 있습니다.<br />
          • 개인정보 열람 요청<br />
          • 개인정보 수정/삭제 요청<br />
          • 개인정보 처리 정지 요청<br />
          • 회원 탈퇴 (마이페이지 → 회원 탈퇴)
        </p>
        <p style={s.p}>권리 행사는 sellerranky@gmail.com으로 문의해 주세요. 10일 이내 조치합니다.</p>

        <h2 style={s.h2}>7. 개인정보 보호책임자</h2>
        <table style={s.table}>
          <tbody>
            <tr><td style={s.td}>성명</td><td style={s.td}>김성현</td></tr>
            <tr><td style={s.td}>소속</td><td style={s.td}>진리커뮤니티</td></tr>
            <tr><td style={s.td}>이메일</td><td style={s.td}>sellerranky@gmail.com</td></tr>
          </tbody>
        </table>

        <h2 style={s.h2}>8. 개인정보 자동 수집 장치 (쿠키)</h2>
        <p style={s.p}>
          서비스는 로그인 상태 유지를 위해 브라우저 localStorage를 사용합니다.
          브라우저 설정에서 저장된 데이터를 삭제할 수 있으나, 삭제 시 로그인이 해제됩니다.
        </p>

        <h2 style={s.h2}>9. 개인정보처리방침 변경</h2>
        <p style={s.p}>
          본 방침은 법령 또는 서비스 변경에 따라 수정될 수 있습니다.
          변경 시 서비스 공지사항을 통해 사전 안내합니다.
        </p>

        <div style={{ borderTop: '0.5px solid #2A3045', marginTop: 40, paddingTop: 20 }}>
          <p style={{ ...s.p, fontSize: 12 }}>시행일: 2026년 3월 22일 | 진리커뮤니티 | sellerranky@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
